export enum InboxTab {
  PRIMARY = 'PRIMARY',
  PROMOTIONS = 'PROMOTIONS',
  SOCIAL = 'SOCIAL',
  UPDATES = 'UPDATES',
  FORUMS = 'FORUMS',
}

export interface InboxTabConfig {
  tab: InboxTab;
  enabled: boolean;
}

export const DEFAULT_INBOX_TABS_CONFIG: InboxTabConfig[] = [
  { tab: InboxTab.PRIMARY, enabled: true },
  { tab: InboxTab.PROMOTIONS, enabled: true },
  { tab: InboxTab.SOCIAL, enabled: true },
  { tab: InboxTab.UPDATES, enabled: true },
  { tab: InboxTab.FORUMS, enabled: true },
];

export const INBOX_TAB_LABEL_KEYS: Record<InboxTab, string> = {
  [InboxTab.PRIMARY]: 'inbox.settings.tabs.primary',
  [InboxTab.PROMOTIONS]: 'inbox.settings.tabs.promotions',
  [InboxTab.SOCIAL]: 'inbox.settings.tabs.social',
  [InboxTab.UPDATES]: 'inbox.settings.tabs.updates',
  [InboxTab.FORUMS]: 'inbox.settings.tabs.forums',
};

export enum InboxSettingsSectionId {
  CATEGORIES = 'CATEGORIES',
  SIGNATURE = 'SIGNATURE',
}

export interface InboxSettingsSectionItem {
  id: InboxSettingsSectionId;
}

export enum SignatureImportStatus {
  IMPORTED = 'imported',
  EMPTY = 'empty',
  FAILED = 'failed',
}

export interface SignatureImportResult {
  status: SignatureImportStatus;
  html: string;
}
